import {
  CTAProps,
  type TokenTextColor,
} from '@volkswagen-onehub/components-core';
import {
  Children,
  type HTMLAttributes,
  cloneElement,
  isValidElement,
  type ReactElement,
} from 'react';
import { StyledCTAGroup } from './CTAGroup.styles';

export interface CTAGroupProps extends HTMLAttributes<HTMLDivElement> {
  onCtaClick?: (id: number, child: ReactElement) => void;
  defaultActiveIndex?: number;
  activeIndex?: number;
  ctaSelectedEmphasis?: CTAProps['emphasis'];
  ctaEmphasis?: CTAProps['emphasis'];
  backgroundColor?: TokenTextColor;
}

const CTAGroup = ({
  children,
  onCtaClick = () => {},
  activeIndex,
  defaultActiveIndex = 0,
  ...restProps
}: CTAGroupProps) => {
  return (
    <StyledCTAGroup {...restProps}>
      {Children.toArray(children).map((child, id) => {
        if (isValidElement<CTAProps>(child)) {
          return cloneElement(child, {
            emphasis: activeIndex === id ? 'primary' : 'tertiary',
            onClick: () => onCtaClick(id, child),
            ...child.props,
          });
        }

        return child;
      })}
    </StyledCTAGroup>
  );
};

export default CTAGroup;
